import React from "react";
import CategoryPage from "./CategoryPage";

export default function PadlockPage() {
  return (
    <CategoryPage
      categoryMatch="padlock"
      title="Padlocks"
      subtitle="High-security padlocks from ABUS and other trusted manufacturers."
      searchPlaceholder="Search padlocks..."
    />
  );
}